/**
 * Where to find the API and the broker, read at startup from /config.json — never
 * compiled in, so one build serves every deployment (Rule 7).
 */
export interface RuntimeConfig {
  apiUrl: string;
  realtimeWsUrl: string;
  /**
   * The privacy policy's address — on the website, which is another origin — linked
   * where a participant gives their name. Optional: without it the notice has no link.
   */
  privacyUrl?: string;
}

export async function loadConfig(): Promise<RuntimeConfig> {
  const res = await fetch("/config.json", { cache: "no-store" });
  if (!res.ok) throw new Error(`config.json: ${res.status}`);
  const c = (await res.json()) as Partial<RuntimeConfig>;
  if (typeof c.apiUrl !== "string" || typeof c.realtimeWsUrl !== "string") {
    throw new Error("config.json must define apiUrl and realtimeWsUrl");
  }
  // A path means "this origin" (the dev proxy, or a reverse proxy in production).
  const ws = new URL(c.realtimeWsUrl, location.href);
  if (ws.protocol === "http:" || ws.protocol === "https:") ws.protocol = ws.protocol === "https:" ? "wss:" : "ws:";
  // Only a web address: config.json is the deployment's, but a link is still a link.
  const privacyUrl =
    typeof c.privacyUrl === "string" && /^https?:\/\//.test(c.privacyUrl) ? c.privacyUrl : undefined;
  return { apiUrl: c.apiUrl.replace(/\/$/, ""), realtimeWsUrl: ws.href, privacyUrl };
}
